export const environment = {
    baseUrl: (typeof window !== 'undefined' && window.__API_BASE__) || process.env.REACT_APP_API_BASE_URL || "https://app-109423.on-aptible.com"
}
